import { render, staticRenderFns } from "./changeHistory.vue?vue&type=template&id=45b1d55b&scoped=true"
import script from "./changeHistory.vue?vue&type=script&lang=js"
export * from "./changeHistory.vue?vue&type=script&lang=js"
import style0 from "./changeHistory.vue?vue&type=style&index=0&id=45b1d55b&prod&scoped=true&lang=scss"
import style1 from "./changeHistory.vue?vue&type=style&index=1&id=45b1d55b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b1d55b",
  null
  
)

export default component.exports